// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__281HU","content":"SubHeader_content__2P-uH","btnBack":"SubHeader_btnBack__3j2x4","line":"SubHeader_line__hsCCc"};